import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem',
    },
    title: {
      width: '500px',
      height: '40px',
    },
  },
  subHeader: {
    main: {
      marginBottom: '1.75rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem',
    },
    title: {
      width: '500px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    button: {
      width: '200px',
      height: '40px',
    },
  },
  list: {
    main: {
      padding: '1.5rem',
    },
    col: {
      marginBottom: '1rem',
    },
    box: {
      height: '100px',
    },
  },
  legend: {
    main: {
      marginTop: '1rem',
    },
    box: {
      height: '40px',
    },
    boxTwo: {
      height: '20px',
    },
  },
};

const SkeletonFareCalendar = (props) => {
  const [className, style] = useStyles(props);
  const { header, subHeader, list, legend } = styles;
  return (
    <Box className={`${className} fr-skeleton`} style={style} dataTestId="skeletonLowFareCalendar">
      <Row gutters>
        <Col style={header.main}>
          <Box className="fr-skeleton-box" style={header.box}>
            <Box className="fr-skeleton-element" style={header.title} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col style={subHeader.main}>
          <Box className="fr-skeleton-box" style={subHeader.box}>
            <Box style={subHeader.title}>
              <Box className="fr-skeleton-element" style={subHeader.button} />
              <Box className="fr-skeleton-element" style={subHeader.button} />
            </Box>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={list.main}>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="4" style={legend.main}>
          <Box className="fr-skeleton-box" style={legend.box} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="5" style={legend.main}>
          <Box className="fr-skeleton-box" style={legend.boxTwo} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFareCalendar.componentName = 'SkeletonFareCalendar';

export default SkeletonFareCalendar;
